import { memo } from 'react';
import { Polygon } from 'react-leaflet';

import { GEOMETRY_TYPE } from '../../constants/map';

import { FILL_OPACITY } from './constants';

function Feature({ children, color, geometry, type, setAnimal }) {
  if (type === GEOMETRY_TYPE.POLYGON) {
    return (
      <Polygon
        pathOptions={{ color, fillColor: color }}
        fillOpacity={FILL_OPACITY.SELECTED}
        positions={geometry}
        onClick={() => setAnimal(type)}>
        {children}
      </Polygon>
    );
  }
}

export default memo(Feature);
